import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import {
  EllipsisOutlined,
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  Col,
  Row,
  Image,
  Space,
  Button,
  Checkbox,
  Form,
  Input,
  Select,
  Table,
  Tag,
  Dropdown,
  Popconfirm,
} from "antd";
import DealIcon from "../../assets/img/dashboard/deals.png";
import userImage from "../../assets/img/main-wrapper/user.jpg";
import { Link } from "react-router-dom";
import { actionGetAllDeals, actionDeleteDeal } from "../../store/actions/dealsAction";
import { actionGetAllBusiness } from "../../store/actions/businessAction";
import { connect } from "react-redux";
import { BASE_URL } from "../config/web-config";

const Deals = (props) => {
  const { actionGetAllDeals, businessLoader
    , businessData, actionGetAllBusiness, dealsData, dealsCount, actionDeleteDeal, deleteDealLoader, dealsLoader, userProfileData
  } = props;
  const [business, setBusiness] = useState("")
  const [code, setCode] = useState("")



  useEffect(() => {
    actionGetAllDeals(0, 10);
    actionGetAllBusiness(0, 20)
  }, [])

  const onFinish = (values) => {
    console.log({ values });
    setBusiness(values.business ? values.business : "");
    setCode(values.code ? values.code : "");
    actionGetAllDeals(
      0,
      10,
      values.business ? values.business : "",
      values.code ? values.code : "",
    );
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onClickPagination = (e) => {
    actionGetAllDeals(
      e.current - 1,
      e.pageSize,
      business ? business : "",
      code ? code : "",
    );
  };


  const confirm = (id, bId) => {
    actionDeleteDeal(id);
  }

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (text) => (
        <Image fallback="data:image/png;base64,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"
          src={text}
          width={50}
          height={50}
          preview={true}
          className="property-img-border"
        />
      ),
    },
    {
      title: "Property Offer",
      dataIndex: "property_offer",
      key: "property_offer",
    },
    {
      title: "Zip Code",
      dataIndex: "zip_code",
      key: "zip_code",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
    },
    {
      title: "Bussiness Name",
      dataIndex: "bussiness_name",
      key: "bussiness_name",
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: "80px",
      fixed: 'right',
      render: (text) => {
        return (
          <Dropdown
            placement="bottom"
            menu={{
              items: [
                {
                  key: "1",
                  label: (
                    <span>
                      <Link to={`/view-deal/${text.id}`} style={{ color: "black" }}>
                        <EyeOutlined
                          style={{
                            color: "#FF9A3E",
                            fontSize: "15px",
                            marginRight: 8,
                          }}
                        />
                        View
                      </Link>
                    </span>
                  ),
                },
              /*   {
                  key: "2",
                  label: (
                    <span>
                      <Link to={`/update-deal/${text.id}`} style={{ color: "black" }}>
                        <EditOutlined
                          style={{
                            color: "#FF9A3E",
                            fontSize: "15px",
                            marginRight: 8,
                          }}
                        />
                        Update
                      </Link>
                    </span>
                  ),
                }, */
                {
                  key: "3",
                  label: (
                    <Popconfirm
                      okButtonProps={{
                        loading: deleteDealLoader,
                      }}
                      onConfirm={() => confirm(text.id)}
                      placement="topLeft"
                      title="Are you sure to delete this Deal ?"
                      okText="Yes"
                      cancelText="No"
                    >
                      <span style={{ color: "black" }}>
                        <DeleteOutlined
                          style={{
                            color: "#FF9A3E",
                            fontSize: "15px",
                            marginRight: 8,
                          }}
                        />
                        Delete
                      </span>
                    </Popconfirm>
                  ),
                },
              ]
            }}
          >
            <span style={{ display: "flex", justifyContent: "center" }}>
              <Space style={{ cursor: "pointer" }}>
                <EllipsisOutlined style={{ fontSize: "20px" }} />
              </Space>
            </span>
          </Dropdown >
        );
      },
    },
  ];


  const businesses = [];
  businessData && businessData.map((business, index) => {
    if (business.is_active) {
      businesses.push({
        key: index,
        label: business.business_name,
        value: business._id,
      });
    }
  })


  const data = [];
  dealsData &&
    dealsData.length > 0 &&
    dealsData.map((d, index) => {
      data.push({
        key: index,
        id: d._id,
        business_id: d.bussiness_id,
        image: d.image,
        property_offer: d.property_offer,
        zip_code: d.zip_code && d.zip_code.length > 1 ? d.zip_code.join(', ') : (d.zip_code && d.zip_code.length === 1 ? d.zip_code[0] : ''),
        code: d.code,
        address: d.address,
        bussiness_name: d.bussiness_name || "",
        end_date: d.to_date ? dayjs(d.to_date).format('DD-MM-YYYY') : '-',
        start_date: d.from_date ? dayjs(d.from_date).format('DD-MM-YYYY') : '-',
      });
    });

  return (

    <Space direction="vertical" size="middle" style={{ display: "flex" }}>
      <Row className="main-card-wrapper" gutter={16}>
        <Col span={24}>
          <div className="card-pink">
            <Row>
              <Col span={20} className="text-card">
                <p className="font-title">Deals of the Day</p>
                <p className="font-text">{dealsCount}</p>
              </Col>
              <Col span={4} className="image-card-pink">
                <Image src={DealIcon} fallback={`${BASE_URL}/nophoto.png`} preview={false} />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row
        className="main-card-wrapper"
        gutter={16}
        justify="space-around"
        align="middle"
      >
        <Col span={4} style={{ fontWeight: "bold", fontSize: "15px" }}>
          Deals Of the Day
        </Col>
        <Col span={16} align="middle">
          {" "}
          <Form
            name="basic"
            layout="inline"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            style={{ justifyContent: "center" }}
          >


            <Form.Item rules={[
              {
                required: false,
                message: 'Not Required!'
              }
            ]} name="business"
              className="delazfixed-select">
              {userProfileData && userProfileData.roles === "admin" &&
                <Select
                  loading={businessLoader}
                  disabled={businessLoader}
                  placeholder="Select Business"
                  allowClear
                  showSearch
                  style={{
                    width: "200px",
                  }}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  options={businesses}
                />
              }
            </Form.Item>
            <Form.Item rules={[
              { required: false, message: 'Not Required!' }
            ]} name="code">
              <Input placeholder="Search by Code" allowClear />
            </Form.Item>

            <Form.Item>
              <Button htmlType="submit">Search</Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={4} align="right">
          <Link to="/create-deal">
            <Button>Create Deals</Button>
          </Link>
        </Col>
        <Col span={24} style={{ marginTop: "10px" }}>
          <Table
            pagination={{
              total: dealsCount, // add total Property Count Here
              hideOnSinglePage: true,
            }}
            sticky={true}
            columns={columns}
            loading={dealsLoader || deleteDealLoader}
            dataSource={data}
            scroll={{
              x: 1500,
              y: window.innerWidth < 1500 ? "40vh" : "50vh",
            }}
            onChange={(e) => onClickPagination(e)}
          />
        </Col>
      </Row>
    </Space>
  );
}

const mapStateToProps = (state) => {
  return {
    dealsLoader: state.dealz.dealsLoader,
    dealsData: state.dealz.dealsData,
    dealsCount: state.dealz.dealsCount,
    deleteDealLoader: state.dealz.deleteDealLoader,
    businessLoader: state.business.businessLoader,
    businessData: state.business.businessData,
    userProfileData: state.auth.userProfileData,
  };
};

export default connect(mapStateToProps, { actionGetAllBusiness, actionGetAllDeals, actionDeleteDeal })(Deals);
